import { render, staticRenderFns } from "./WindChartCarousel.vue?vue&type=template&id=1a4f763b&scoped=true&"
import script from "./WindChartCarousel.vue?vue&type=script&lang=js&"
export * from "./WindChartCarousel.vue?vue&type=script&lang=js&"
import style0 from "./WindChartCarousel.vue?vue&type=style&index=0&id=1a4f763b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f763b",
  null
  
)

export default component.exports